import createAxios from './axiosHttp';
export const courierService = {
  getCouriers,
  getCourierServices,
  getCourierShippingMethods
};

function getCouriers() {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `customer/${user.extraData.customerId}/couriers`;
  return axios.get(urlPath);
}

function getCourierServices(courierKey) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `customer/${user.extraData.customerId}/couriers/services?courier=${encodeURIComponent(courierKey)}`;
  return axios.get(urlPath);
}

function getCourierShippingMethods(courierKey) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `customer/${user.extraData.customerId}/couriers/shipping-methods?courier=${encodeURIComponent(courierKey)}`;
  return axios.get(urlPath);
}
